import { CREDIT_REPORT_ACCOUNT_STATUS, CREDIT_REPORT_ACCOUNT_TYPE, FFAccountHistoryData, FFAccountHolderInfo, FFCreditReportData, PreprocessedData } from "./data";




export default class DataPreprocessor {


  static async preprocessAccountInfoFromPayload(payload: FFCreditReportData) {
    try {
      // console.log("Payload Input..............Im here one", payload, " payloadsdf" );
      let accountInfo = payload?.accountInfo;
      // console.log("payload to DataPreprocessor", accountInfo)
      // console.log("asdfasdf___", payload)

      const preprocessedData: PreprocessedData = {
        ACTIVE: {
          SECURED: [],
          UNSECURED: [],
          OTHERS: [],
        },
        CLOSED: {
          CLOSED: [],
        },
      };

      for (const account of accountInfo) {
        const newAccount = { ...account };

        if (newAccount.accountStatus === CREDIT_REPORT_ACCOUNT_STATUS.ACTIVE) {
          const accountType = await DataPreprocessor.preprocessAccountType(newAccount.accountType);
          preprocessedData.ACTIVE[accountType] = preprocessedData.ACTIVE[accountType] || [];
          preprocessedData.ACTIVE[accountType].push(newAccount);

          // payment History preprocessing 
          if (newAccount.accountHistoryList) {
              const paymentHistoryData = await DataPreprocessor.preprocessPaymentHistoryData(newAccount.accountHistoryList);

              // adding Loan_Type 
              newAccount.Preprocessed_Payment_History = paymentHistoryData.history;
              newAccount.NumberOfOnTimePayments = paymentHistoryData.onTimePayments;
              newAccount.NumberOfMissedPayments = paymentHistoryData.missedPayments;
          }


        } else if (account.accountStatus === CREDIT_REPORT_ACCOUNT_STATUS.CLOSED) {
          // Step - 2.1 : adding Loan_Type 
          const loanType = await DataPreprocessor.preprocessAccountType(account.accountType);

          if (newAccount.accountHistoryList) {
            // Step - 3 : Payment History Creation 
            const paymentHistoryData = await DataPreprocessor.preprocessPaymentHistoryData(newAccount.accountHistoryList);

            // adding Loan_Type 
            newAccount.Preprocessed_Payment_History = paymentHistoryData.history;
            newAccount.NumberOfOnTimePayments = paymentHistoryData.onTimePayments;
            newAccount.NumberOfMissedPayments = paymentHistoryData.missedPayments;
          }

          preprocessedData.CLOSED.CLOSED.push(newAccount);

        }
      }

  
        // console.log("preprocessedData______inside if condition", preprocessedAccountInfo)
        payload.preprocessed_accountInfo = preprocessedData;
        // console.log("preprocessedData______outside", payload.preprocessed_accountInfo?.ACTIVE.UNSECURED)

      // } else {
      //   console.error(
      //     "The path to CAIS_Account in the payload is invalid. Preprocessed data could not be assigned."
      //   );
      // }

      return payload;

    } catch (error) {
      console.log("error in DataPreprocessor", error);
      throw error;
    }

  }


  static async preprocessAccountType(accountType: CREDIT_REPORT_ACCOUNT_TYPE) {
    switch (accountType) {
      case CREDIT_REPORT_ACCOUNT_TYPE.UNSECURED: {
        return "UNSECURED"
      }
      case CREDIT_REPORT_ACCOUNT_TYPE.SECURED: {
        return "SECURED"
      }
      case CREDIT_REPORT_ACCOUNT_TYPE.OTHERS: {
        return "OTHERS"
      }
      default: {
        return "OTHERS"
      }
    }
  }

  static async preprocessPaymentHistoryData(accountHistoryList: FFAccountHistoryData[]) {
    const historyData: Array<any> = [];
    let onTimePayments = 0;
    let missedPayments = 0;


    const profileMap = new Map<number, { year: number, months: Array<any> }>();
    if (Array.isArray(accountHistoryList)) {
      accountHistoryList.sort((a, b) => {
        // const dateA = new Date(Number(a.Year), Number(a.Month) - 1);
        // const dateB = new Date(Number(b.Year), Number(b.Month) - 1);
        const dateA = new Date(+a.year, +a.month - 1);
        const dateB = new Date(+b.year, +b.month - 1);

        return dateA.getTime() - dateB.getTime();
      });

      for (const entry of accountHistoryList) {
        // const year = parseInt(entry.Year, 10);
        // const month = parseInt(String(entry.Month), 10) - 1; // JS months are 0-indexed
        // const daysPastDue = parseInt(String(entry.Days_Past_Due), 10);

        const year = +entry.year;
        const month = +entry.month - 1;
        const daysPastDue = +entry.daysPastDue;

        // if (!profileMap.has(year)) {
        //   profileMap.set(year, { year: year, months: new Array(12).fill(null) });
        // }
        if (!profileMap.has(year)) {
          profileMap.set(year, { year: year, months: new Array(12).fill({ isNoData: true }) });
        }



        const currentYearData = profileMap.get(year)!.months;

        if (daysPastDue > 0) {
          currentYearData[month] = { isMissed: true };
          missedPayments++;
        } else {
          currentYearData[month] = { isOnTime: true };
          onTimePayments++;
        }
      }
    }
    profileMap.forEach((value) => {
      historyData.push(value);
    });

    // Sort the final array by year
    historyData.sort((a, b) => a.year - b.year);

    return {
      history: historyData,
      onTimePayments,
      missedPayments,
    };
  }

  static async preprocessNameFromPayload(payload: FFCreditReportData) {
    try {
      const makeFullName = (acc: any) => {
        const parts = [
          acc.firstName,
          acc.middleName1,
          acc.middleName2,
          acc.lastName
        ];

        return parts
          .filter(p => p && typeof p === "string" && p.trim() !== "")
          .map(p => p.trim().replace(/\.+$/, ""))
          .join(" ");
      };

      const allNames = payload.accountHolderInfoList
        .map(makeFullName)
        .filter(name => name.trim() !== "");

      if (allNames.length === 0) return "";

      let fullName = allNames.reduce((a, b) => (b.length > a.length ? b : a));
      payload.accountHolderFullName = fullName;
      // console.log("fullName is here ", fullName);
      return payload;

    } catch (error) {
      console.log("error while preprocessing name from payload", error);
    }

  }

  static async preprocessMobileNumber(payload: FFCreditReportData) {
    try {
      const mobiles = payload.accountHolderInfoList
        .map(item => item.mobile)
        .filter((m): m is string => typeof m === "string" && m.trim() !== "")
        .map(m => m?.trim());

      if (mobiles.length === 0) return "";

      // pick the mobile number with maximum length
      if (mobiles.length === 0) return "";

      let phoneNumber = mobiles.reduce((a, b) => (b.length > a.length ? b : a));

      if (phoneNumber.length < 10) {
        phoneNumber = phoneNumber.padEnd(10, "X");
      }

      payload.accountHolderInfoList[0].mobile = phoneNumber;
      return payload;

    } catch (error) {
      console.log("error while preprocessing Mobile Number", error);
    }
  }

  static async preprocessTotalAccounts(payload: FFCreditReportData) {
    payload.accountsSummary.totalAccounts = payload.accountsSummary.accountsActiveCount + payload.accountsSummary.accountsClosedCount;
    return payload;

  }




  // preprocessors for PaymentHistory 
  static async preprocessPaymentHistory(payload: FFCreditReportData) {

  }
  // ******** 
}